export default __webpack_public_path__ + "static/14-40affdc6a07040f148054c769ca09962.png";